const buildWebStorageApiStrategy = (store) => () => {
  const load = ({ key }) => {
    const stored = store.getItem(key);
    return stored === null ? undefined : stored;
  };

  const save = ({ key, value }) => store.setItem(key, value);
  const remove = ({ key }) => store.removeItem(key);

  const getConfig = () => ({
    isExpirySupported: false,
  });

  return { load, save, remove, getConfig };
};

export const localStorageStrategy = buildWebStorageApiStrategy(window.localStorage);

export const sessionStorageStrategy = buildWebStorageApiStrategy(window.sessionStorage);

export const cookieStorageStrategy = () => {
  /* Being that location.hostname may return either a fully qualified
   * domain name (i.e., <subdomain>.<2nd-level-domain>.<tld>) or an
   * IP address, this function will ensure that you either get the IP address
   * or a domain that includes only the 2nd-level-domain and the tld.
   */
  const getCookieDomain = () => {
    const regexIP = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
    const regexDomain = /((?<ld2>[a-z-]+)\.)?(?<tld>[a-z]+$)/i;
    // eslint-disable-next-line no-restricted-globals
    const { hostname } = location;

    const isIp = !!regexIP.exec(hostname);
    if (isIp) {
      return hostname;
    }

    const {
      tld,
      ld2,
    } = regexDomain.exec(hostname).groups;

    if (!ld2) {
      // probably localhost or some locally mapped domain
      return tld;
    }

    return `${ld2}.${tld}`;
  };

  const load = ({ key }) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${key}=`);
    return parts.length === 2
      ? parts.pop().split(';').shift()
      : undefined;
  };

  const domain = getCookieDomain();

  const save = ({ key, value, expiry }) => {
    let cookie = `${key}=${value}`;
    if (expiry) {
      cookie = `${cookie}; domain=${domain}; Path=/; expires=${expiry.toGMTString()}`;
    }
    document.cookie = cookie;
  };

  const remove = ({ key }) => {
    document.cookie = `${key}=; domain=${domain}; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
  };

  const getConfig = () => ({
    isExpirySupported: true,
  });

  return { load, save, remove, getConfig };
};
